<template>
  <v-container grid-list-md>
    <v-layout row justify-center>
      <v-flex xs12 md9>
        <v-layout column align-center justify-space-between>
          <v-sheet elevation="3">
            <v-form>
              <v-container fluid>
                <v-layout row wrap justify-center>
                  <h3 class="mb-2">Conditions générales</h3>
                  <iframe
                    :src="`${rootUrl}/cgu/`"
                    style="width: 100%; height: 30vh"
                  ></iframe>
                  <v-flex xs12>
                    <v-checkbox
                      style="margin-top: 0"
                      v-model="accepted"
                      label="J'ai lu et j'accepte les conditions générales"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex xs6 class="d-flex justify-center">
                    <v-btn flat @click="$router.push('/')" color="primary"
                      >Annuler</v-btn
                    >
                  </v-flex>
                  <v-flex xs6 class="d-flex d-flex-initial justify-center">
                    <v-btn outline @click="submit" color="accent"
                      >Valider</v-btn
                    >
                  </v-flex>
                </v-layout>
              </v-container>
              <v-snackbar v-model="showError" :bottom="true">
                Une erreur a eu lieu
              </v-snackbar>
            </v-form>
          </v-sheet>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { ROOT_URL } from "../../../webapp-commons/config";
import { fetchHil2 } from "../utils";

export default {
  name: "CguSign",
  data: function() {
    return {
      accepted: false,
      showError: false,
      rootUrl: ROOT_URL
    };
  },
  methods: {
    async submit() {
      if (!this.accepted) {
        return;
      }
      try {
        await fetchHil2("post", "/user/finalize");
        this.$router.push("/");
      } catch (e) {
        this.showError = true;
      }
    }
  }
};
</script>

<style scoped></style>
